import { HealthFactor } from './HealthFactor'
import { Page } from '@/components'
import styles from './Dashboard.module.scss'
import { CurrentLTV } from './CurrentLTV'
import { useAAVEDataProvider } from '@/context'
import { motion } from 'framer-motion'
import { NETWORKS } from '@/common/networks'
import { isExtension } from '@/helpers/browserApi'
import EmailCard from './Cards/EmailCard'
import ExtensionCard from './Cards/ExtensionCard'

const Placeholder = ({ title, text }: { title: string; text: string }) => {
    return (
        <div className={styles.placeholder}>
            <h2 className={styles.placeholderTitle}>{title}</h2>
            <p className={styles.placeholderText}>{text}</p>
        </div>
    )
}

const Dashboard = () => {
    const { aaveData, isLoading, error, chainIdWithFallback } = useAAVEDataProvider()
    const isNetworkSupported = NETWORKS.some((network) => network.chainId === chainIdWithFallback)
    const selectedNetwork = NETWORKS.find((network) => network.chainId === chainIdWithFallback)

    return (
        <Page className={styles.wrapper}>
            <motion.div className={styles.container}>
                <div className={styles.header}>
                    <h1 className={styles.title}>AAVE v3 positions</h1>
                    <p className={styles.text}>
                        Total Collateral: {aaveData?.totalCollateralETH || '-$'} | Total Debt:{' '}
                        {aaveData?.totalDebtETH || '-$'}
                    </p>
                </div>
                {isNetworkSupported ? (
                    <>
                        {isLoading && <Placeholder title="Loading AAVE data..." text="" />}
                        {aaveData && !isLoading && (
                            <motion.div className={styles.content}>
                                <HealthFactor />
                                <CurrentLTV />
                            </motion.div>
                        )}
                        {!aaveData && !error && !isLoading && (
                            <Placeholder
                                title={`No AAVE positions on ${selectedNetwork?.name || 'this network'}`}
                                text="You may have positions on another network. Use the network selector above to check."
                            />
                        )}
                        {!aaveData && error && !isLoading && (
                            <Placeholder
                                title="Failed to fetch AAVE data"
                                text="Please try again later."
                            />
                        )}
                    </>
                ) : (
                    <Placeholder
                        title="Unsupported network"
                        text="Please switch to a supported AAVE network to view your positions."
                    />
                )}

                {/* TODO: Other network handling */}
                <motion.div className={styles.cardsWrapper} layout>
                    <EmailCard />
                    {!isExtension && <ExtensionCard />}
                </motion.div>
            </motion.div>
        </Page>
    )
}

export default Dashboard
